import { TextField } from "~components";
import { translate } from "~utils";

import styles from "./VerificationCodeInput.module.css";

type VerificationCodeInputProps = {
  isDisabled: boolean;
  onChange: (value: string) => void;
  value?: string;
  label?: string;
};

export function VerificationCodeInput(props: VerificationCodeInputProps) {
  const { value, onChange, isDisabled, label } = props;

  function handleOnChange(value: string) {
    if (value.length > 4) {
      return;
    }
    onChange(value);
  }

  return (
    <div className={styles.root} style={{ paddingTop: "8px" }}>
      <TextField
        type="number"
        label={label}
        value={value}
        onChange={handleOnChange}
        inputMode="numeric"
        pattern="[0-9]{4}"
        maxLength={4}
        placeholder={translate("VERIFICATION_CODE_INPUT_PLACEHOLDER")}
        isDisabled={isDisabled}
      />
    </div>
  );
}
